import React, { useRef, useEffect, useMemo } from "react";
import styled from "styled-components";

import { DependencySelector } from "./DependencySelector";
import { ShowMenu } from "../../../../components/ShowMenu";
import Container from "@appsinti/ui-core/header/Container";
import { getToday } from "@appsinti/ui-core/dateAndTime/utils";

import useI18n from "@appsinti/i18n/useI18n";
import { Link } from "react-router-dom";
import HomeIcon from "../../../../../../resources/img/home-icon.svg";
import { useApps } from "pages/home/AppProvider";

import CustomLink from "@appsinti/ui-core/CustomLink";
import { useParams } from 'react-router-dom';
import { Mini } from '@appsinti/weather-frontend';
import IApp from '@appsinti/common-utils/interfaces/IApp';

const DISPLAY_DATE_FORMAT = "iiii MMMM dd, yy";

const Icon = styled(Link)`
  flex: 0 0 23px;
  max-width: 23px;
  width: 20px;
  height: 20px;
  display: block;

  img {
    max-width: 100%;
    width: auto;
    height: auto;
  }
`;

const Date = styled.div`
  flex: 0 0 23%;
  max-width: 23%;
  font-size: 1.2rem;
`;

const WeatherWidget = styled(CustomLink)`
  display: block;
  max-width: 50px;
  margin-left: 3px;
  margin-bottom: -3px;
  font-size: 13px;
`;

const Header: React.FC<{
  setHeaderHeight: React.Dispatch<React.SetStateAction<number | undefined>>;
  headerHeight: number | undefined;
}> = ({ setHeaderHeight, headerHeight }) => {
  const { selectedLang } = useI18n();
  const containerRef = useRef<HTMLHeadElement>(null);
  const { summaryApp, apps } = useApps();
  const { groupId } = useParams<{ groupId: string }>();
  
  const weatherApp: IApp|null = useMemo(()=>{
    if(!apps || !groupId) return null;
    
    const selectedApps = apps[groupId];
    const app = selectedApps.find( 
      app => app.blueprint.type === "navigation" && app.module === 'weather'
    );
    
    return !!app ? app : null;     
  },[apps, groupId]);

  useEffect(() => {
    setHeaderHeight(containerRef.current?.clientHeight);
  }, [containerRef.current?.clientHeight]);

  return (
    <Container ref={containerRef}>
      {summaryApp === null ? (
        <Date>{getToday(selectedLang, DISPLAY_DATE_FORMAT)}</Date>
      ) : (
        <Icon to={"/"}>
          <img src={HomeIcon} alt="Appsinti" />
        </Icon>
      )}
      {!!weatherApp && (
        <WeatherWidget key={weatherApp.id} to={`/app/${weatherApp.id}`}>
          <Mini appId={weatherApp.id} config={{showIcon: true}}/>
        </WeatherWidget>
      )}
      <DependencySelector headerHeight={headerHeight} />
      <ShowMenu headerHeight={headerHeight} />
    </Container>
  );
};

export default Header;
